import { BaseApi } from '@/main/baseApi';

import { DMS_MODULE, NAME } from './constants';

class SmsEmailProvider extends BaseApi {
	async fetchEmailTemplate(props: object): Promise<Record<string, any>> {
		return this.fetch(`/${DMS_MODULE}/${NAME}/EmailTemplate`, props);
	}

	async sendEmail(props: object): Promise<Record<string, any>> {
		return this.uploadMultipart(`/${DMS_MODULE}/${NAME}/EmailSend`, props);
	}

	async fetchSmsTemplate(props: object): Promise<Record<string, any>> {
		return this.fetch(`/${DMS_MODULE}/${NAME}/SmsTemplate`, props);
	}

	async sendSms(props: object): Promise<Record<string, any>> {
		return this.post(`/${DMS_MODULE}/${NAME}/SmsSend`, props);
	}

	async hromadnaSmsSend(props: object): Promise<Record<string, any>> {
		return this.post(`/${DMS_MODULE}/${NAME}/HromadnaSmsSend`, props);
	}

	async sendOTP(props: any): Promise<Record<string, any>> {
		return this.post(`/${DMS_MODULE}/${NAME}/SendOTP`, props);
	}

	async verifyOTP(props: any): Promise<Record<string, any>> {
		return this.post(`/${DMS_MODULE}/${NAME}/VerifyOTP`, props);
	}
}
export const apiProvider = new SmsEmailProvider(DMS_MODULE, NAME);
